import { secondAxios } from "../../../api/axios";

const verifyVendorRoute = "/doc-transmittal/verify/";

export const verifyVendor = async (token) => {
  const { data } = await secondAxios.get(verifyVendorRoute + token);
  return data;
};
